import { v4 as uuidv4 } from 'uuid';
import { ChannelItemType } from '../sic-lib/enums/ChannelItemType';
import {
    ToastContactAlert,
    ToastItem,
    ToastMessageReceived,
    ToastStatus,
    ToastType,
} from '../types/ToastItem';

export function createErrorToast(message: string): ToastItem {
    return {
        type: ToastType.generic,
        status: ToastStatus.error,
        toastId: uuidv4(),
        text: message,
        autoHide: 10000,
    };
}

export function createSuccessToast(message: string): ToastItem {
    return {
        type: ToastType.generic,
        status: ToastStatus.success,
        toastId: uuidv4(),
        text: message,
        autoHide: 10000,
    };
}

export function createMessageReceivedToast(
    contactId: number,
    contactName: string,
    channelType: ChannelItemType,
    preview: string,
): ToastMessageReceived {
    return {
        type: ToastType.messageReceived,
        status: ToastStatus.info,
        toastId: uuidv4(),
        text: preview,
        contactId,
        contactName: contactName || 'Unknown',
        channelType: channelType,
        autoHide: 10000,
    };
}

export function createContactAlertToast(
    contactId: number,
    title: string,
    body: string | undefined,
): ToastContactAlert {
    return {
        type: ToastType.contactAlert,
        status: ToastStatus.info,
        toastId: uuidv4(),
        contactId,
        title: title,
        text: body || '',
        autoHide: 10000,
    };
}
